import { render } from "./clpga.vue?vue&type=template&id=ea5c62d2&scoped=true"
import script from "./clpga.vue?vue&type=script&lang=js"
export * from "./clpga.vue?vue&type=script&lang=js"

import "./clpga.vue?vue&type=style&index=0&id=ea5c62d2&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit_master\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea5c62d2"]])

export default __exports__